import { defineI18nConfig, useRuntimeConfig } from '#imports';
import localesDe from '~/assets/locales/de.json';
import localesEn from '~/assets/locales/en.json';
import localesPl from '~/assets/locales/pl.json';
import { Locale } from './types/locales';

export default defineI18nConfig(() => {
  const config = useRuntimeConfig();

  const messages: Record<Locale, any> = {
    de_at: localesDe,
    de_ch: localesDe,
    de_de: localesDe,
    en_com: localesEn,
    en_us: localesEn,
    pl_pl: localesPl,
    // TODO: Add other translations
    nl_nl: localesEn,
    en_uk: localesEn,
    nl_be: localesEn,
    fr_be: localesEn,
    fr_fr: localesEn,
    es_es: localesEn,
    ja_jp: localesEn,
    zh_cn: localesEn,
    fr_ch: localesEn,
  };

  if (config.public.IS_HEADER_FOOTER_EXPORT) {
    // In the shop export, we overwrite the default locale with the German locale, as the shop is only available in German
    messages.en_com = localesDe;
  }
  return {
    messages,
    fallbackLocale: Locale.EN_COM,
    silentTranslationWarn: true,
  };
});
